// Configuration for the stacked area chart
// Colors and tick counts follow CNN visuals style guide

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  // Margins adjusted for axis labels and direct area labels on the right
  const margins = {
    top: 20,
    right: 40, // Extra space for direct area labels
    bottom: 30,
    left: 50, // Space for y-axis tick labels
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  // CNN category colors for the two authorities
  const colors = {
    ice: '#07473A', // CNN Yellow
    cbp: '#53A796', // Dark gold/brown
  };

  // CNN style: 3-4 ticks on mobile, 4-5 on desktop
  const yTickCount = isMobile ? 4 : 5;
  const xTickCount = isMobile ? 4 : 6;

  return {
    height,
    initialWidth,
    initialHeight,
    isMobile,
    margins,
    width,
    colors,
    yTickCount,
    xTickCount,
  };
}
